import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { VerifyEmailPage } from '@/features/auth/verify-email-page';

/** Адреса приходить у параметрі, щоб екран міг її показати після перезавантаження. */
const verifyEmailSearchSchema = z.object({
	email: z.email().optional(),
});

export const Route = createFileRoute('/verify-email')({
	validateSearch: verifyEmailSearchSchema,
	component: VerifyEmailPage,
	staticData: { fullScreen: true },
});
